/* eslint-disable react/jsx-curly-newline */
/* eslint-disable @typescript-eslint/no-shadow */
import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';
import CheckBox from '@/components/elements/Form/BetCheckBox';
import {
  BetMethod,
  FirstThreeRacerData,
  FirstThreeRacerList,
  RacerNumber,
} from '@/modelTypes';

import {
  ActionButtons,
  Table,
  TableData,
  TableHeader,
  TableWrapper,
} from '../style';

interface BoxSheetProps {
  bicycleCount: number;
  racerNumbers: RacerNumber[];
  firstThreeRacerList: FirstThreeRacerList;
  setFirstThreeRacerData: React.Dispatch<
    React.SetStateAction<FirstThreeRacerData>
  >;
  isDisabledBicycleNumber: (bicycleNum: number) => boolean;
}

const BoxSheet: React.FC<BoxSheetProps> = ({
  bicycleCount,
  racerNumbers,
  firstThreeRacerList,
  setFirstThreeRacerData,
  isDisabledBicycleNumber,
}) => {
  const getBracketNumber = (bicycleNum: number) => {
    const racer = racerNumbers.find(
      racerNum => racerNum.bicycleNum === bicycleNum,
    );
    return racer!.bracketNum;
  };

  const isChecked = (bicycleNum: number): boolean => {
    const racerList = firstThreeRacerList.reduce((prev, next) =>
      prev.concat(next),
    );
    return racerList.some(racerNums => racerNums.bicycleNum === bicycleNum);
  };

  const handleClick = (value: string, checked: boolean) => {
    const strArray = value.split('-');
    const bicycleNum = Number(strArray[0]);
    const bracketNum = Number(strArray[1]);

    setFirstThreeRacerData(prev => {
      const newList = { ...prev };
      if (checked) {
        newList[BetMethod.Box].forEach((_, i) => {
          newList[BetMethod.Box][i].push({
            bicycleNum,
            bracketNum,
          });
        });
      } else {
        newList[BetMethod.Box].forEach((_, i) => {
          newList[BetMethod.Box][i] = prev[BetMethod.Box][i].filter(
            racerNums =>
              !(
                racerNums.bicycleNum === bicycleNum &&
                racerNums.bracketNum === bracketNum
              ),
          );
        });
      }
      return newList;
    });
  };

  const arrayCheck = () => {
    setFirstThreeRacerData(prev => {
      const newList = { ...prev };
      const activeList = racerNumbers.filter(
        rn => !isDisabledBicycleNumber(rn.bicycleNum),
      );
      newList[BetMethod.Box].forEach((_, i) => {
        newList[BetMethod.Box][i] = [...activeList];
      });
      return newList;
    });
  };

  const unsetArrayCheck = () => {
    setFirstThreeRacerData(prev => {
      const newList = { ...prev };
      newList[BetMethod.Box].forEach((_, i) => {
        newList[BetMethod.Box][i] = [];
      });
      return newList;
    });
  };

  return (
    <TableWrapper>
      <Table>
        <thead>
          <tr>
            <TableHeader>BOX</TableHeader>
          </tr>
        </thead>
        <tbody>
          {[...Array(bicycleCount)].map((_, i) => (
            <tr key={`tr-${i}`}>
              <TableData disabled={isDisabledBicycleNumber(i + 1)}>
                <CheckBox
                  value={i + 1}
                  checked={isChecked(i + 1)}
                  num={i + 1}
                  onChange={() =>
                    handleClick(
                      `${i + 1}-${getBracketNumber(i + 1)}`,
                      !isChecked(i + 1),
                    )
                  }
                  disabled={isDisabledBicycleNumber(i + 1)}
                />
              </TableData>
            </tr>
          ))}
        </tbody>
      </Table>
      <ActionButtons>
        <Button
          bgColor="secondary"
          size="s"
          radius="s"
          width="40px"
          height="40px"
          onClick={() => arrayCheck()}
        >
          全
        </Button>
        <Button
          bgColor="secondary"
          size="s"
          outline
          radius="s"
          width="40px"
          height="40px"
          onClick={() => unsetArrayCheck()}
        >
          消
        </Button>
      </ActionButtons>
    </TableWrapper>
  );
};

export default BoxSheet;
